module.exports = "/assets/landing-rc/promo/delice-photo@2x.jpg?+wGl88G";